// 定义英文语言包对象
export default {
  Language: 'English',
  // 导航栏
  nav_cashier: 'Cashier',
  
  // 支付收银台
  payment_title: 'Payment Cashier',
  payment_amount_label: 'Please enter payment amount',
  payment_method_title: 'Select payment method',
  payment_method_wechat: 'WeChat Pay',
  payment_method_alipay: 'Alipay',
  payment_method_unionpay: 'UnionPay',
  payment_button: 'Pay Now HK${amount}',
  payment_loading: 'Processing...',
  
  // 支付调起页面
  payment_password_title: 'Please enter payment password',
  payment_password_placeholder: 'Please enter 6-digit payment password',
  payment_password_hint: 'Please enter payment password in {paymentMethod}',
  payment_cancel: 'Cancel',
  payment_confirm: 'Confirm Payment',
  
  // 支付成功提示
  payment_success: 'Payment Successful',
  payment_amount: 'Payment Amount:',
  payment_method: 'Payment Method:',
  payment_transaction_id: 'Transaction ID:',
  payment_time: 'Payment Time:',
  payment_ok: 'OK',
  
  // 弹窗提示
  payment_amount_error: 'Please enter a valid payment amount',
  payment_password_error: 'Please enter 6-digit payment password',
  payment_error: 'Payment initialization failed',
  payment_request_error: 'Payment request failed, please try again later',
  
  // 银联支付
  unionpay_scan_title: 'UnionPay QR Code Payment',
  unionpay_scan_hint: 'Please download the QR code and scan with Cloud QuickPass APP',
  unionpay_download_button: 'Download QR Code',
  unionpay_download_success: 'QR code saved to album',
  unionpay_download_failed: 'Download failed, please try again',
  unionpay_mobile_save_hint: 'Long press the image and select "Save Image"',
  unionpay_desktop_save_hint: 'Please right-click and save the image in the new window',
  unionpay_mobile_long_press: 'Long press to save'
};